import PropTypes from 'prop-types';

const heroBannersPayloadType = PropTypes.shape({
  eoq: PropTypes.shape,
});

export default heroBannersPayloadType;
